module.exports = __webpack_public_path__ + "left.27pyYBXv.svg";